import Config from 'config';
import { call, put, select } from 'redux-saga/effects';

import { getUserId } from '../../session/getters';
import waitForSession from '../../../lib/wait-for-session';

import {
  REPORTS_DOWNLOAD_DISCOUNT_REPORT_SUCCESS,
  REPORTS_DOWNLOAD_DISCOUNT_REPORT_ERROR,
  ON_REPORTS_DOWNLOAD_ERROR,
  ON_CODES_MOUNT_ERROR
} from '../actions';

export function* downloadReport() {
  const userId = yield select(getUserId);
  try {
    const urlString = `${Config.api.host}/api/v2/users/${userId}/discount_codes.csv`;
    const result = yield fetch(urlString, { method: 'HEAD' });
    switch (result.status) {
      case 200:{
        yield put({ type: REPORTS_DOWNLOAD_DISCOUNT_REPORT_SUCCESS });
        window.location.href = urlString;
        break;
      }
      default:
        yield put({ type: REPORTS_DOWNLOAD_DISCOUNT_REPORT_ERROR });
        break;
    }
  }
  catch (e) {
    yield put({ type: ON_REPORTS_DOWNLOAD_ERROR });
  }
}

export function* onCodesMount() {
  yield call(waitForSession);

  try {
    const userId = yield select(getUserId);

    if (!userId) {
      throw new Error('No user - aborting');
    }
  }
  catch (e) {
    yield put({ type: ON_CODES_MOUNT_ERROR });
  }
}

export function* redirectToHomepage() {
  window.location.href = `${Config.api.host}`;
  return false;
}



// WEBPACK FOOTER //
// ./src/modules/codes/actions/sagas.js